// Blog Quiz
const onRun = () => {
    const quizContainers = document.querySelectorAll(".quiz-buttons");
    if (quizContainers) {
        quizContainers.forEach((container) => {
            const buttons = container.querySelectorAll('button');
            const correctAnswer = container.getAttribute('data-correct-answer');

            if (buttons && correctAnswer) {
                buttons.forEach((item) => {
                    item.addEventListener('click', function () {

                        this.classList.add('is-wrong');
                        container.querySelector(`button[data-answer="${correctAnswer}"]`).classList.add('is-correct')

                        container.querySelectorAll('button').forEach((button) => {
                            button.disabled = true;
                        });
                    });
                });
            }
        })
    }
};

if(document.readyState !== 'loading') {
    onRun();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        onRun()
    });
}

